/**
 * The initials bubble used wherever a person appears on an alert — the assignee column of the
 * alert list, the comment rows and the workflow history on the detail view.
 *
 * The tone is derived from the name rather than assigned, so one person keeps one colour
 * across every list and every session without anything having to store the mapping.
 */
const AVATAR_TONES = [
  'bg-rose-500', 'bg-orange-500', 'bg-amber-500', 'bg-emerald-500',
  'bg-teal-500', 'bg-sky-500', 'bg-indigo-500', 'bg-violet-500',
];

export function initialsOf(name?: string | null) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

export interface AvatarProps {
  name?: string | null;
  className?: string;
}

export function Avatar({ name, className = 'h-8 w-8 text-[11px]' }: AvatarProps) {
  const seed = String(name || '?');
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return (
    <span
      title={name || undefined}
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full font-semibold text-white ${AVATAR_TONES[h % AVATAR_TONES.length]} ${className}`}
    >
      {initialsOf(name)}
    </span>
  );
}

export default Avatar;
